module.exports = "<span class=\"price-tag-label\">{{ price }}</span>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/price-tag/price-tag.component.html
// module id = ./web/modern/components/price-tag/price-tag.component.html
// module chunks = 0